import TweenMax from "gsap";

var head1, head2, head3, head4;


$(function () {
    head1 = document.querySelectorAll('.head1')[0];
    head2 = document.querySelectorAll('.head2')[0];
    head3 = document.querySelectorAll('.head3')[0];
    head4 = document.querySelectorAll('.head4')[0];

    $(window).scroll(function () {
        fixEd();
    });
    $(window).resize(function () {
        fixEd();
    });
    setInterval(function () {
        $(window).trigger('resize');
    }, 400);
    if($('body').hasClass('home')){
        setTimeout(function () {
            crossFadeHeaders(2);
        }, 600);
    }
    // setTimeout(function () {
    //     crossFadeLeft(2);
    // }, 600);
});

function fixEd() {
    let window_width = $(window).width();
    let window_height = $(window).height();
    let scrollTop = $(window).scrollTop();
    if ($('body').hasClass('home')) {
        let top = (scrollTop < 40) ? 0 : scrollTop * 2;
        let height = window_height - top + 40;
        $('.home-visual').css({'height': height + 'px'});
        $('.home-visual .left').css({'margin-top': -top / 2 + 'px', 'margin-left': -top / 3 + 'px'});
        $('.home-visual .right').css({'margin-left': top + 'px'});
        $('.home-visual .head').css({'margin-top': -top / 2 + 'px'});
        $('.home-visual .shoutout').css({'margin-top': (top-270) / 3 + 'px'});
        $('body.home').css({'padding-top': height + 'px'});
    }

    let pixels = 40;
    if (window_height > window_width) {
        pixels = 40;
    }
    if ($(window).scrollTop() > pixels) {
        $('body').addClass('fixed');
    }
    else {
        $('body').removeClass('fixed');
    }
}

var h = 1;


function crossFadeHeaders(speed) {
    if (h === 4) {
        h = 1;
        head1.style.opacity = 1;
        head2.style.opacity = 0;
        head3.style.opacity = 0;
        TweenMax.to(head4, speed, {opacity: 0});
    }
    else {
        h++;
        var el = document.querySelectorAll('.head' + h);
        TweenMax.to(el, speed, {opacity: 1});
    }
    setTimeout(function () {
        crossFadeHeaders(speed);
    }, (speed * 600) + 1200)
}

